export type SpecialCondition = {
  label: string;
  value: string;
};

export const OtherSpecialConditionValue = "other";
